import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=6cbc4083&scoped=true&"
import script from "./Discussion.vue?vue&type=script&lang=js&"
export * from "./Discussion.vue?vue&type=script&lang=js&"
import style0 from "./Discussion.vue?vue&type=style&index=0&id=6cbc4083&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc4083",
  null
  
)

export default component.exports